import {HFormStructure} from "../../ui/types";

export const modalStructure: HFormStructure = [
  ['city_from', 'city_to'], ['route', 'price']
]
